import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.qnalist');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-qnalist',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.qnalist/view.scss */
/* src/app/component.qnalist/view.scss: no such file or directory */`],
})
export class ComponentQnalistComponent implements OnInit {
  public openedIndex: number | null = null;
  public items: any[] = [];

  constructor(@Inject( Service) public service: Service) { }

  public async ngOnInit() {
    await this.service.init();

    // 🔹 샘플 데이터 (8개 리스트)
    this.items = [
      {
        title: "임상 한의학 종합DB - 2025.10.16 08:36",
        db: "임상 한의학 종합DB",
        type: "수동",
        qas: [
          {
            status: "임시저장",
            type: "practice",
            level: "medium",
            question: "백회혈의 위치와 주치종을 설명하시오.",
            answer: "백회혈은 두정부 정중선상 전발제 후 5촌에 위치하며..."
          },
          {
            status: "검수대기",
            type: "theory",
            level: "easy",
            question: "경락의 기본 개념은 무엇인가?",
            answer: "경락은 기혈이 운행하는 통로입니다. 12경맥과 기경팔맥이 있으며..."
          },
          {
            status: "검수대기",
            type: "theory",
            level: "easy",
            question: "경락의 기본 개념은 무엇인가?",
            answer: "경락은 기혈이 운행하는 통로입니다. 12경맥과 기경팔맥이 있으며..."
          },
          {
            status: "검수대기",
            type: "theory",
            level: "easy",
            question: "경락의 기본 개념은 무엇인가?",
            answer: "경락은 기혈이 운행하는 통로입니다. 12경맥과 기경팔맥이 있으며..."
          },          
          {
            status: "검수대기",
            type: "theory",
            level: "easy",
            question: "경락의 기본 개념은 무엇인가?",
            answer: "경락은 기혈이 운행하는 통로입니다. 12경맥과 기경팔맥이 있으며..."
          },         
          {
            status: "검수대기",
            type: "theory",
            level: "easy",
            question: "경락의 기본 개념은 무엇인가?",
            answer: "경락은 기혈이 운행하는 통로입니다. 12경맥과 기경팔맥이 있으며..."
          }
        ]
      },
      {
        title: "임상 한의학 종합DB - 2025.10.16 08:36",
        db: "임상 한의학 종합DB",
        type: "자동",
        qas: [
          {
            status: "검수대기",
            type: "diagnosis",
            level: "medium",
            question: "소양병의 특징과 치료법은?",
            answer: "소양병은 인건 목열 등으로..."
          },
          {
            status: "검수대기",
            type: "diagnosis",
            level: "medium",
            question: "소양병의 특징과 치료법은?",
            answer: "소양병은 인건 목열 등으로..."
          },
          {
            status: "검수대기",
            type: "diagnosis",
            level: "medium",
            question: "소양병의 특징과 치료법은?",
            answer: "소양병은 인건 목열 등으로..."
          },
          {
            status: "검수대기",
            type: "diagnosis",
            level: "medium",
            question: "소양병의 특징과 치료법은?",
            answer: "소양병은 인건 목열 등으로..."
          }
        ]
      },
      {
        title: "황체내경 벡터DB - 2025.10.16 08:36",
        db: "황체내경 벡터DB",
        type: "자동",
        qas: [
          {
            status: "검수대기",
            type: "theory",
            level: "easy",
            question: "황체의 기능을 설명하시오.",
            answer: "황체는 배란 후 형성되어..."
          },
          {
            status: "검수대기",
            type: "theory",
            level: "easy",
            question: "황체의 기능을 설명하시오.",
            answer: "황체는 배란 후 형성되어..."
          },
          {
            status: "검수대기",
            type: "theory",
            level: "easy",
            question: "황체의 기능을 설명하시오.",
            answer: "황체는 배란 후 형성되어..."
          },

        ]
      },
      {
        title: "동의보감 벡터DB - 2025.10.16 08:35",
        db: "동의보감 벡터DB",
        type: "자동",
        qas: [
          {
            status: "검수대기",
            type: "practice",
            level: "medium",
            question: "진맥의 최적 시간과 이유는?",
            answer: "진맥은 아침에 하는 것이 좋습니다..."
          }
        ]
      },
      {
        title: "동의보감 내경편 1차",
        db: "Unknown",
        type: "수동",
        qas: [
          {
            status: "검수대기",
            type: "practice",
            level: "easy",
            question: "경락의 정의를 설명하시오.",
            answer: "경락은 기혈이 흐르는 통로로..."
          }
        ]
      },
      {
        title: "동의보감 내경편 2차",
        db: "Unknown",
        type: "자동",
        qas: [
          {
            status: "검수대기",
            type: "theory",
            level: "medium",
            question: "사기의 종류를 말하시오.",
            answer: "풍, 한, 서, 습, 조, 화의 여섯 가지를 말합니다."
          }
        ]
      },
      {
        title: "동의보감 입형편 1차",
        db: "Unknown",
        type: "자동",
        qas: [
          {
            status: "검수대기",
            type: "diagnosis",
            level: "medium",
            question: "형상의 개념을 설명하시오.",
            answer: "형상은 외형적 징후와 체질적 특성을 말합니다."
          }
        ]
      },
      {
        title: "동의보감 잡병편 1차",
        db: "Unknown",
        type: "수동",
        qas: [
          {
            status: "검수대기",
            type: "theory",
            level: "medium",
            question: "잡병편의 주요 내용은?",
            answer: "잡병편은 내과, 외과, 부인과 등 다양한 질병을 다룹니다."
          }
        ]
      }
    ];
  }

  // ✅ 클릭 시 열기/닫기
  public toggleItem(index: number): void {
    this.openedIndex = this.openedIndex === index ? null : index;
  }
}

export default ComponentQnalistComponent;